module.exports = __webpack_public_path__ + "img/koica.768f3ed0.png";